import {ReactNode, useEffect, useRef, useState} from 'react';
import { useHistory } from 'react-router-dom';
import { isChallenge, SESSAO_VERSAO, useAuth } from '../contexts/AuthenticationContext';
import {Alert, Col, Spinner} from 'react-bootstrap';
import CryptoJS from "crypto-js";
import {downloadInvoice} from "../Utils/dowloadInvoice";
import logoImg from "../assets/netcomet.png";

export function Authentication() {
	const history = useHistory();

	const { signIn } = useAuth();

	const [loading, setLoading] = useState(true);
	const [message, setMessage] = useState<ReactNode>('');
	//signIn troca de identidade quando o contexto re-renderiza (ex.: carga das notificacoes); sem esta trava o
	//efeito rodava duas vezes e o segundo push relativo ('anexos/...') saia de /anexos/<token> e caia em
	///anexos/anexos/<token>
	const executado = useRef(false);

	useEffect(() => {
		if (executado.current) return;
		executado.current = true;

		const urlParams = new URLSearchParams(window.location.search);
		const documentParam = urlParams.get('d');
		const phoneParam = urlParams.get('t');
		const tokenParam = urlParams.get('t');
		const invoiceParam = urlParams.get('i');

		//navegador nao lembrado: a API pediu o codigo de confirmacao. O login cuida do codigo e volta ao destino.
		const pedirCodigo = (documento: string, telefone: string, destino: string) => {
			history.replace('/login?d=' + encodeURIComponent(documento) + '&t=' + encodeURIComponent(telefone) + '&retorno=' + encodeURIComponent(destino));
		};

		//JWT da sessao guardada, se for deste bundle, nao venceu e e do mesmo documento; senao null
		const sessaoValidaDoCliente = (documento: string): string | null => {
			try {
				const sessao = JSON.parse(localStorage.getItem('session_netcomet') || 'null');
				const agora = new Date().getTime() / 1000;
				const docSessao = String(sessao?.data?.cdoc || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
				if (sessao?.token && sessao.versao === SESSAO_VERSAO && sessao.exp > agora && docSessao === documento.toUpperCase()) {
					return sessao.token as string;
				}
			} catch (e) {
			}
			return null;
		};

		if (documentParam && phoneParam && invoiceParam) {
			const documento = documentParam.replace(/\.|-/g, '').trim();
			const telefone = phoneParam.replace(/\(|\)|-/g, '').trim();
			const destino = '/pagamento_avulso/' + invoiceParam;
			signIn(documento, telefone, null)
				.then((resultado) => {
					if (isChallenge(resultado)) {
						pedirCodigo(documento, telefone, destino);
						return;
					}
					history.replace(destino);
				}).catch(() => {
					history.replace('/login');
				})
		} else if (tokenParam && !documentParam) {
			let obj_json = JSON.parse(atob(tokenParam));
			let key = CryptoJS.PBKDF2(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_KEY as string, process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_SALT as string, { hasher: CryptoJS.algo.SHA512, keySize: 64/8, iterations: 999});
			let decrypted = CryptoJS.AES.decrypt(obj_json.ciphertext, key, { iv: CryptoJS.enc.Hex.parse(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_IV_HEX as string)});
			let dataParameters = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

			if (dataParameters.r === 'anexos') {
				const documento = dataParameters.d.replace(/\.|-/g, '').trim();
				const telefone = dataParameters.t.replace(/\(|\)|-/g, '').trim();
				const destino = '/anexos/' + tokenParam;
				//o proprio link vai no login: a API confere que e um link de anexos deste cliente e nao pede o codigo
				signIn(documento, telefone, null, undefined, undefined, tokenParam)
					.then((resultado) => {
						if (isChallenge(resultado)) {
							pedirCodigo(documento, telefone, destino);
							return;
						}
						history.replace(destino);
					}).catch(() => {
						history.replace('/login');
					})
			} else if (dataParameters.local === 'boleto') {
				//link de boleto (bot de WhatsApp): o proprio link vai no login; assinado pela API, dispensa o codigo.
				//Link antigo (sem assinatura) ou navegador nao lembrado: pede o codigo e volta para este mesmo link.
				const documento = dataParameters.d.replace(/\.|-/g, '').trim();
				const telefone = dataParameters.t.replace(/\(|\)|-/g, '').trim();
				const destino = '/autenticacao?t=' + encodeURIComponent(tokenParam);
				//voltando do codigo com sessao valida deste mesmo cliente: usa o token dela, sem novo login (senao, com
				//"lembrar este navegador" desmarcado, o link pediria o codigo de novo a cada volta)
				const sessaoAtual = sessaoValidaDoCliente(documento);
				if (sessaoAtual) {
					setLoading(false);
					setMessage(downloadInvoice(sessaoAtual, dataParameters.id_movimentacao, dataParameters.pix));
					return;
				}
				signIn(documento, telefone, null, undefined, undefined, tokenParam)
					.then((resultado) => {
						if (isChallenge(resultado)) {
							pedirCodigo(documento, telefone, destino);
							return;
						}
						setLoading(false);
						setMessage(downloadInvoice(resultado.token, dataParameters.id_movimentacao, dataParameters.pix));
					}).catch((erro) => {
						setLoading(false);
						setMessage(<Alert variant="danger">{typeof erro === 'string' ? erro : 'Não foi possível abrir o boleto.'}</Alert>);
					});
			} else {
				history.replace('/login');
			}
		} else {
			history.replace('/login');
		}
	},[history, signIn]);

	return (
		<>
			{loading && <div className="vh-100 justify-content-center align-items-center d-flex">
				<Spinner animation="border" role="status"/>
			</div>}
			{!loading && <div className="vh-100 justify-content-center align-items-center d-grid ms-3 me-3">
					<Col md={12} sm={12} className="text-center">
							<img src={logoImg} className="mb-5" alt="Logo Netcomet"/>
							{message}
					</Col>
			</div>}
		</>
	);
}
